// extracted by mini-css-extract-plugin
export default {"overlay":"Drawer_overlay__cT73f","overlayVisible":"Drawer_overlayVisible__0qXNp","drawer":"Drawer_drawer__GzlYt","items":"Drawer_items__1TMIo"};